'use client';
import styled, { css } from 'styled-components';
import { generateContentIconStyle } from '@ui/icons';
import { variants } from './variants';

export const StyledRadioInput = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  gap: ${({ theme }) => theme.spacing(4)};
  width: 100%;
`;

export const Label = styled.label`
  align-items: center;
  border-radius: 500px;
  padding: ${({ theme }) => theme.spacing(4)};
  ${({ checked, variant, theme, showRadioIcon }) => {
    const status = checked ? 'checked' : 'unchecked';

    return css`
      background-color: ${theme.colors.get(
        variants[variant][status].background,
      )};
      border: 2px solid
        ${({ error, disabled, theme }) =>
          error
            ? theme.colors.status.errorPrimary
            : disabled
            ? 'transparent'
            : theme.colors.get(variants[variant][status].border)};
      color: ${theme.colors.get(variants[variant][status].text)};
      ${showRadioIcon
        ? css`
            cursor: pointer;
            display: grid;
            grid-template-columns: 30px 1fr;
            flex: 1;
            text-align: center;
            ${({ theme }) => theme.typography.body}
            &::before {
              ${checked
                ? generateContentIconStyle('radiobox-marked')
                : generateContentIconStyle('radiobox-blank')};
              width: 24px;
              height: 24px;
              background-color: ${theme.colors.get(
                variants[variant][status].iconBackground,
              )};
            }
          `
        : css`
            ${({ theme }) => theme.typography.button}
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            position: relative;
            min-width: 156px;
            text-align: center;
          `}

      &:hover {
        border-color: ${props =>
          props.variant === 'cancel'
            ? props.theme.colors.status.errorPrimary
            : props.variant !== 'primary'
            ? props.theme.colors.border.dark
            : props.theme.colors.hero.lilac};
        outline: none;
      }

      &:active {
        border-color: ${props => props.theme.colors.text.primary};
      }

      &:disabled {
        opacity: 0.5;
      }
      &:hover,
      &:focus-within {
        cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
        border: 2px solid
          ${({ error, theme, disabled }) =>
            error
              ? theme.colors.status.errorPrimary
              : disabled
              ? 'transparent'
              : theme.colors.get(variants[variant].hoverColor)};
      }
    `;
  }}

  text-wrap: nowrap;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const StyledFieldset = styled.fieldset`
  border-width: 0px;
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
`;

export const StyledLegend = styled.legend`
  position: absolute;
  height: 1px;
  width: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;
